import { merchantKnowledgeListItemSchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { merchantKnowledgeSuggestionViewSchema } from "@redotech/shopper-agent-knowledge-common/suggested-merchant-knowledge-view";
import * as z from "zod";

export const listKnowledge = {
  name: "listKnowledge" as const,
  input: z
    .object({
      /** Present switches to index-backed search; absent browses the table. */
      query: z.string().optional(),
      limit: z.number().int().positive().max(200).optional(),
      offset: z.number().int().nonnegative().optional(),
      maxSuggestions: z.number().int().nonnegative().optional(),
    })
    .strict(),
  output: z.object({
    articles: z.array(merchantKnowledgeListItemSchema),
    /** Pending proposals only, capped, shown above the articles. */
    suggestions: z.array(merchantKnowledgeSuggestionViewSchema),
    /** Articles matching, for the pager. Suggestions are not paged. */
    totalArticleCount: z.number(),
  }),
};
